<ps-ui-card>
  <h6 psCardHeader>TOTAL COST</h6>
  <p psCardContent class="survey-status">
    <button class="stats-menu-btn" [psUiDropdownToggleFor]="TotalCost">
      {{ content.totalCostLabel }}
    </button>
    <ps-ui-dropdown class="status-dropdown" #TotalCost="psUiDropdown">
      <button
        *ngIf="userRole === 'buyer' || userRole === 'operator'"
        psUiDropdownItem
        (click)="
          content.totalCostLabel = 'At Launch';
          content.totalCostValue = content.totalCost.launch
        "
      >
        At Launch
      </button>
      <button
        psUiDropdownItem
        (click)="
          content.totalCostLabel = 'Projected';
          content.totalCostValue = content.totalCost.projected
        "
      >
        Projected
      </button>
      <button
        psUiDropdownItem
        (click)="
          content.totalCostLabel = 'Current';
          content.totalCostValue = content.totalCost.current
        "
      >
        Current
      </button>
    </ps-ui-dropdown>
  </p>
  <p psCardFooter>
    {{ content.totalCostValue | currency : content.currencySymbol }}
  </p>
</ps-ui-card>
